import axios from 'axios'
import { InvoiceAddress, PaymentParams } from '../../../schema/payment'
import { getApiUrl, PAYMENT_WEBSHOP_URL } from '../../util/api/api'

const startPayment = (
  paymentMethod: string,
  paymentParams?: PaymentParams,
  poNumber?: string,
  invoiceAddress?: InvoiceAddress,
) =>
  axios.post<any>(
    getApiUrl(`${PAYMENT_WEBSHOP_URL}/payment`),
    {
      paymentMethod,
      paymentParams,
      poNumber,
      invoiceAddress
    },
    {
      withCredentials: true,
    },
  )

export default startPayment
